import React, { ChangeEventHandler, useState } from 'react'
import {
  FormContext,
  ContractAndVehicleSection, SectionHeader, SharingSection, UrlGenerationSection
} from './supplier_review_link_form'
import { FormContextShape } from './supplier_review_link_form/FormContext'

interface SupplierReviewLinkFormProps {
  baseUrl: string
  selectOptions: FormContextShape['selectOptions']
  sharingTooltip: string
}
export const SupplierReviewLinkForm: React.FC<SupplierReviewLinkFormProps> = (
  { baseUrl, selectOptions, sharingTooltip }
) => {
  const [vehicleId, setVehicleId] = useState('')
  const [contractId, setContractId] = useState('')
  const [shouldShare, setShouldShare] = useState(false)

  const handleVehicleChange: ChangeEventHandler<HTMLSelectElement> = (e) => {
    setVehicleId(e.target.value)
    setContractId('')
  }

  const handleContractChange: ChangeEventHandler<HTMLSelectElement> = (e) => {
    setContractId(e.target.value)
  }

  const handleShareChange: ChangeEventHandler<HTMLInputElement> = () => {
    setShouldShare(!shouldShare)
  }

  const formContext = {
    baseUrl,
    contractId,
    vehicleId,
    shouldShare,
    handleContractChange,
    handleVehicleChange,
    handleShareChange,
    selectOptions
  }

  return (
    <FormContext.Provider value={formContext}>
      <section className='review-collection-section'>
        <div id='custom-review-form'>
          <SectionHeader title='Customized Review Form'>
            <p>Using this tool, you can customize the information collected on your company review form.</p>
          </SectionHeader>

          <ContractAndVehicleSection
            description="Select any Contract Information you'd like pre-populated on the review form:"
          />

          <SharingSection
            checkboxLabel="I'd like reviews submitted via this form to be shared with me by default"
            tooltip={sharingTooltip}
          />

          <UrlGenerationSection
            urlButtonText='SHOW URL'
            urlFormLabel="Your campaign's review form URL"
          />
        </div>
      </section>
    </FormContext.Provider>
  )
}

export default SupplierReviewLinkForm
